import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const PageBanner = ({ title, subtitle, image, breadcrumbs }) => {
  return (
    <section className="page-banner">
      <div
        className="page-banner-bg"
        style={{ backgroundImage: `url('${image}')` }}
      />
      <div className="page-banner-overlay" />
      <div className="page-banner-content">
        <h1 className="page-banner-title">{title}</h1>
        {subtitle && <p className="page-banner-subtitle">{subtitle}</p>}
        <nav className="breadcrumb-nav" aria-label="Breadcrumb">
          <ol className="breadcrumb-list">
            <li>
              <Link to="/" className="breadcrumb-link">
                <Home size={14} />
                Home
              </Link>
            </li>
            {breadcrumbs && breadcrumbs.map((crumb, i) => (
              <li key={i}>
                <ChevronRight size={14} className="breadcrumb-sep" />
                {crumb.link ? (
                  <Link to={crumb.link} className="breadcrumb-link">{crumb.label}</Link>
                ) : (
                  <span className="breadcrumb-current">{crumb.label}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </section>
  );
};

export default PageBanner;
